module.exports = __webpack_public_path__ + "static/media/screen_ad.ac83a6a2.swf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screen_ad.swf
// module id = 958
// module chunks = 0